import moment from 'moment-timezone';

/**
 * Keep only per-day buckets whose `dayKey` falls within the selected date range (inclusive).
 *
 * Wider session fetches can produce overnight segments on adjacent calendar days; callers
 * (timeline saga) apply this so the UI matches the user's filter.
 *
 * **Consumers:** Timeline, App Usage, Screenshots, and Dashboard overview all use
 * `sessionsByDay` from Redux after `GET_SESSIONS` — they do not duplicate this logic.
 *
 * @param {Array<{ dayKey: string }>} processed - Days from saga grouping (each has `dayKey` YYYY-MM-DD)
 * @param {string} startDate - Range start YYYY-MM-DD
 * @param {string} endDate - Range end YYYY-MM-DD
 * @param {string} [timeZone] - Member/report timezone (IANA)
 * @returns {typeof processed}
 */
export function filterSessionsByDayToSelectedRange(
  processed,
  startDate,
  endDate,
  timeZone
) {
  if (!processed?.length) return processed || [];
  const tz = timeZone || moment.tz.guess();
  const filterStart = moment
    .tz(startDate, 'YYYY-MM-DD', tz)
    .format('YYYY-MM-DD');
  const filterEnd = moment.tz(endDate, 'YYYY-MM-DD', tz).format('YYYY-MM-DD');
  return processed.filter(
    (day) => day.dayKey >= filterStart && day.dayKey <= filterEnd
  );
}
